import { useQuery, useQueryClient } from '@tanstack/react-query';
import jwtAxios from '@crema/services/auth/JWT';
import { AuthUserType } from '@crema/models/AuthUser';
import { UserType } from '@crema/models/account';
import { getLocalStorage, LOCAL_STORAGE_NAMES } from '@libs/storage/src/lib/local';
import { AxiosError } from 'axios';
import Cookies from 'js-cookie';

export const useAuthUserQuery = () => {
  const queryClient = useQueryClient();

  const { data, error } = useQuery<AuthUserType | UserType, AxiosError>({
    queryKey: ['/api/users/me'],
    enabled: !!getLocalStorage(LOCAL_STORAGE_NAMES.TOKEN),
    queryFn: async ({ queryKey }) => {
      const [url] = queryKey;

      // cookie에 shop_no가 있으면 파라미터로 추가
      const shopNo = Cookies.get('shop_no');
      const params = shopNo ? { shopNo: shopNo } : {};

      const response = await jwtAxios.get(url, {
        params: params,
      });
      return response.data;
    },
    select: (data) => {
      return {
        ...data,
        watermark: 'https://cdn.pod.shop/watermarks/jyp_watermark.png',
      };
    },
  });

  const refreshData = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['/api/users/me'],
    });
  };

  return { data, error, refreshData };
};
